import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import SummaryApi from "../../common";

const AddSection = () => {
  const [formData, setFormData] = useState({
    section_name: "",
    isActive: "", // Replaced 'idno' with 'isActive'
  });

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    // Prepare the data for the API request
    const data = {
      section_name: formData.section_name,
      isActive: formData.isActive, // Use 'isActive' instead of 'idno'
    };

    try {
      // Make the API call to create a new section using fetch
      const response = await fetch(SummaryApi.createSections.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (response.ok && result.status) {
        // Success
        setSuccessMessage("Section created successfully!");
        setFormData({ section_name: "", isActive: "" }); // Reset the form
      } else {
        // If the API response indicates failure
        setErrorMessage("Failed to create section. Please try again.");
      }
    } catch (error) {
      // Handle errors (e.g., network issues)
      setErrorMessage("An error occurred. Please try again later.");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handleReset = () => {
    setFormData({
      section_name: "",
      isActive: "", // Reset isActive field
    });
  };

  return (
    <div className="">
      <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-3xl font-semibold mb-4 sm:mb-5 md:mb-6 text-center sm:text-left">
        Sections
      </h1>

      <nav className="text-gray-600 mb-4">
        <ol className="flex flex-wrap items-center space-x-2 text-sm sm:text-base md:text-lg lg:text-xl xl:text-xl">
          <li>
            <Link to="/dashboard" className="hover:text-[#ffa404]">
              Home
            </Link>
          </li>
          <li className="text-[#ffa404]">
            <MdKeyboardArrowRight size={25} />
          </li>
          <li className="text-[#ffa404]">
            <Link to="/addsection" className="hover:text-[#ffa404]">
              Add New Section
            </Link>
          </li>
        </ol>
      </nav>

      <div className="bg-white shadow-md rounded-lg p-6 mt-6 h-[70vh] sm:h-[60vh] md:h-[60vh] lg:h-[70vh] xl:h-[60vh]">
        <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center sm:text-left">
          Add New Section Schedule
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Form fields */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {/* Teacher Name */}
            <div>
              <label className="block text-[16px] font-medium text-gray-500">
               Section Name*
              </label>
              <input
                type="text"
                name="section_name"
                value={formData.section_name}
                onChange={handleChange}
                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                required
              />
            </div>

            {/* Is Active */}
            <div>
              <label className="block text-[16px] font-medium text-gray-500">
                Is Active*
              </label>
              <select
                name="isActive"
                value={formData.isActive}
                onChange={handleChange}
                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                required
              >
                <option value="">Select Status</option>
                <option value="1">Active</option>            
                <option value="0">Inactive</option>
              </select>
            </div>          
          </div>

          {/* Error and Success Messages */}        
          {errorMessage && (
            <div className="text-red-600 font-semibold">{errorMessage}</div>
          )}
          {successMessage && (
            <div className="text-green-600 font-semibold">{successMessage}</div>
          )}
                                                    
          <div className="flex flex-col sm:flex-row space-x-0 sm:space-x-4 mt-4">
            <button
              type="submit"
              className={`p-4 ${loading ? "bg-gray-400" : "bg-[#ffa404]"}`}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save"}
            </button>
            <button
              type="button"
              onClick={handleReset}
              className="p-4 bg-gray-300 text-black rounded-md hover:bg-gray-400 flex items-center justify-center mt-4 sm:mt-0"
            >
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSection;
